import "./vaultItem.css";
import Inpt from "../inpt/Inpt";
import VaultItem from "./VaultItem";

export default function VaultItemNumerous({
  title,
  inputs,
  token,
  data,
  inputChange,
  showTitle = true,
}) {
  return (
    <div className="vaultItem">
      {showTitle ? <h2>{title}</h2> : ""}

      {inputs[token] ? (
        ""
      ) : (
        <Inpt
          label={"TokenAbbreviation"}
          name={data[0].name}
          val={inputs[data[0].name]}
          type="text"
          placeholder={data[0].placeholder}
          onChg={inputChange}
        />
      )}
      {inputs[data[0].name] ? (
        <>
          {/* <Inpt
            label={title + ", " + inputs[data[0].name]}
            name={data[1].name}
            val={inputs[data[1].name]}
            type="text"
            placeholder={data[1].placeholder}
            onChg={inputChange}
          />
          <Inpt
            label={title + ", $"}
            name={data[2].name}
            val={inputs[data[2].name]}
            type="text"
            placeholder={data[2].placeholder}
            onChg={inputChange}
          />
          <Inpt
            label={inputs[data[0].name] + "/$"}
            name={data[3].name}
            val={inputs[data[3].name]}
            type="text"
            placeholder={data[3].placeholder}
            onChg={inputChange}
          /> */}
          <VaultItem
            title={title}
            showTitle={false}
            token={data[0].name}
            data={[
              { name: data[1].name, placeholder: data[1].placeholder },
              { name: data[2].name, placeholder: data[2].placeholder },
              { name: data[3].name, placeholder: data[3].placeholder },
            ]}
            inputs={inputs}
            inputChange={inputChange}
          />
        </>
      ) : (
        ""
      )}
    </div>
  );
}
